import { transcriptionRouteSchema } from "@rosc/contracts";
import { env } from "@/env";

export async function resolveRecordingRoute({
  roomId,
  signal,
}: {
  roomId?: string;
  signal?: AbortSignal;
}) {
  if (env.VITE_TRANSCRIPTION_ROUTING_ENABLED !== "true") return undefined;
  const controller = new AbortController();
  const abort = () => controller.abort();
  const timer = setTimeout(abort, 10000);
  signal?.addEventListener("abort", abort, { once: true });
  if (signal?.aborted) abort();
  try {
    const response = await fetch(
      new URL("/api/v2/transcription-routes", env.VITE_API_V2_BASE_URL),
      {
        method: "POST",
        credentials: "include",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(roomId ? { roomId } : {}),
        cache: "no-store",
        signal: controller.signal,
      },
    );
    if (!response.ok) throw Error("Recording route unavailable");
    return transcriptionRouteSchema.parse(await response.json());
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener("abort", abort);
  }
}
